import { render, staticRenderFns } from "./DeviceComment.vue?vue&type=template&id=eb491074&scoped=true&"
import script from "./DeviceComment.vue?vue&type=script&lang=js&"
export * from "./DeviceComment.vue?vue&type=script&lang=js&"
import style0 from "./DeviceComment.vue?vue&type=style&index=0&id=eb491074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb491074",
  null
  
)

export default component.exports